import React, { useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { useTranslation } from '../../locale/useTranslation'
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME } from '../../framework/constant/constant';
import * as API from "../../framework/API/api"
import { toast } from 'react-toastify';

const MediaEpisodeSettingForm = (props) => {

    const { onCancel, entityName, data } = props;
    const lang = useTranslation();
    const blankDataItem = {
        ...data,
        Colors: {
            Foreground: data.Settings?.Colors?.Foreground ?? "",
            Background: data.Settings?.Colors?.Background ?? ""
        },
        RouterCommand: data.Settings?.RouterCommand ?? "",
        HardDisk: data.Settings?.HardDisk ?? ""
    }
    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = async (e) => {
        if (e.target.name == "Foreground" || e.target.name == "Background") {
            setDataItem({ ...dataItem, Colors: { ...dataItem.Colors, [e.target.name]: e.target.value } });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const onSyncSeasonColorsWithEps = async () => {
        let dataRes = await API.syncSeasonConfigInEpisodes({
            Season_id: data?._id,
            ["Settings.Colors"] : dataItem?.Colors ? dataItem?.Colors : null
        });

        if (dataRes.success) {
            toast.success(dataRes.message, {
                position: toast.POSITION.TOP_RIGHT
            })
        } else {
            toast.error(dataRes.message, {
                position: toast.POSITION.TOP_RIGHT
            })
        }

    }

    const onSyncRouterCommandWithEps = async () => {

        let dataRes = await API.syncSeasonConfigInEpisodes({
            Season_id: data?._id,
            ["Settings.RouterCommand"]: dataItem?.RouterCommand ?? ""
        });
        if (dataRes.success) {
            toast.success(dataRes.message, {
                position: toast.POSITION.TOP_RIGHT
            })
        } else {
            toast.error(dataRes.message, {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    const handleSubmit = async () => {
        const finalData = {
            _id: data?._id,
            SID: data?.SID,
            Settings: {
                Colors: {
                    Foreground: dataItem?.Colors?.Foreground ?? "",
                    Background: dataItem?.Colors?.Background ?? ""
                },
                RouterCommand: dataItem?.RouterCommand ?? "",
                HardDisk: dataItem?.HardDisk ?? "",
            }
        }
        console.log(finalData)
        const res = await API.saveData(entityName, finalData)
        if (res.success) {
            toast.success(lang.settings_updated_successfully_message, {
                position: toast.POSITION.TOP_RIGHT
            })
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            })
        }
        onCancel();
    }

    return (
        <>
            <BossDialog title={lang.setting_header} onClose={onCancel} width={"48%"}>
                <EditPageHeader onSubmit={handleSubmit} onCancel={onCancel} showTitle={false}/>
                <div className="mt-2 row p-2">
                    <div className="col-12">
                        <div className="row align-items-end">
                            <div className="col-5 form-group">
                                <label htmlFor="Foreground">{lang.foreground_color_sm_label}</label>
                                <input type="text" id="Foreground" className="form-control form-control-sm" name="Foreground" value={dataItem?.Colors?.Foreground} onChange={onChange} />
                            </div>
                            <div style={{ padding: '24px 16px 0px 2px' }} className="col-1 form-group">
                                <input type="color" className="form-control form-control-sm" name="Foreground" value={dataItem?.Colors?.Foreground} onChange={onChange} title={lang.text_color_label} />
                            </div>
                            <div style={{ padding: '0px 2px 0px 16px' }} className="col-4 form-group">
                                <label htmlFor="">{lang.background_color_sm_label}</label>
                                <input type="text" className="form-control form-control-sm" name="Background" value={dataItem?.Colors?.Background} onChange={onChange} />
                            </div>
                            <div style={{ padding: '24px 16px 0px 2px' }} className="col-1 form-group">
                                <input type="color" className="form-control form-control-sm" name="Background" value={dataItem?.Colors?.Background} onChange={onChange} title={lang.text_color_label} />
                            </div>
                            {entityName === ENTITYNAME.Season && <div style={{ padding: '24px 0px 0px 2px' }} className="col form-group">
                                <button type="button" style={{ height: "30px" }} title='Sync Color With Episodes'
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                    onClick={onSyncSeasonColorsWithEps}>
                                    <i className="fa-solid fa-palette fa-xs"></i>
                                </button>
                            </div>}
                        </div>
                        <div className="row align-items-end mt-2">
                            <div className="col-5 form-group">
                                <label htmlFor="RouterCommand">{lang.router_command_label}</label>
                                <input type="text" id="RouterCommand" className="form-control form-control-sm" name="RouterCommand" value={dataItem?.RouterCommand} onChange={onChange} />
                            </div>
                            {entityName === ENTITYNAME.Season && <div style={{ padding: '24px 16px 0px 2px' }} className="col form-group">
                                <button type="button" style={{ height: "30px" }} title='Sync Router Command With Episodes'
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                    onClick={onSyncRouterCommandWithEps}>
                                    <i className="fa-solid fa-sync fa-xs"></i>
                                </button>
                            </div>}
                            <div className="col-6 form-group">
                                <label htmlFor="HardDisk">{lang.hard_disk_label}</label>
                                <input name="HardDisk" type="text" id="HardDisk" className="form-control form-control-sm" value={dataItem?.HardDisk} onChange={onChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog>
        </>
    )
}

export default MediaEpisodeSettingForm